import { categoryWomen } from '@/assets/images';

export default function CategoryWomen() {
  return (
    <section id="mujer" className="py-24 md:py-32 bg-cream-50">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div className="hover-zoom overflow-hidden bg-white">
          <img
            src={categoryWomen}
            alt="Selección de prendas de mujer de Surkana en Sano: chaqueta de punto con ribete naranja, blusa verde de lunares, jersey de cuello alto y camisa floral con pantalón de piel"
            title="Colección mujer Sano Llíria"
            className="w-full h-auto block object-contain object-top"
          />
        </div>
        <div className="lg:pl-10">
          <p className="text-[11px] tracking-widest-xl text-ink-500 mb-6">COLECCIÓN 2026</p>
          <h2 className="font-display text-5xl md:text-7xl text-ink-900 mb-8">Mujer</h2>
          <div className="w-16 h-px bg-ink-900/40 mb-8"></div>
          <p className="text-ink-700 text-base md:text-[17px] leading-relaxed max-w-md mb-10">
            Descubre nuestra selección de moda femenina, pensada para acompañarte en cada ocasión. Prendas atemporales, tejidos cuidados y una estética que celebra la elegancia natural.
          </p>
          <a href="#colecciones" className="btn-line inline-flex items-center gap-3 text-[11px] tracking-widest text-ink-900 cursor-pointer whitespace-nowrap">
            VER COLECCIÓN
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}